import { AxiosError } from "axios"
import { getBikeFleet, updateBikeStatus } from "../api/bikeFleetApi"
import { createAsyncThunkCustom } from "store/hooks"


// Thunk for get bike list
export const getBikeFleetThunk = createAsyncThunkCustom(
	"bikeFleet/getBikeFleet",
	async (
		//status est utilisé dans le builder ne pas supprimé du type
		{ operator }: { status: string; operator: string },
		{ rejectWithValue }
	) => {
		try {
			const { res: bikeFleetList, getError } = await getBikeFleet(operator)
			if (getError() || !bikeFleetList) throw getError()
			return bikeFleetList
		} catch (err) {
			const error = err as unknown as AxiosError
			return rejectWithValue(error.message)
		}
	}
)

// Thunk for update status bike
export const updateBikeStatusThunk = createAsyncThunkCustom(
	"bikeFleet/updateBike",
	async ({
		bikesToUpdate,
		bikeStatus,
	}: {
		bikesToUpdate: Array<{ operator: string; bikeId: string; rowVersion: string }>
		bikeStatus: number
	}) => {
		const errorsResponse = []
		const successfulResponses = []
		for (const bike of bikesToUpdate) {
			try {
				const { res: response, getError } = await updateBikeStatus({
					...bike,
					bikeStatus: bikeStatus,
				})

				if (getError() || !response) {
					throw getError()
				}

				successfulResponses.push(response)
			} catch (err) {
				const error = err as unknown as AxiosError
				errorsResponse.push(bike.bikeId)
			}
		}

		return {
			error: errorsResponse,
			success: successfulResponses,
		}
	}
)
